export enum UserAddMessages {
  PageTitle = 'Add user',
}
